import React from 'react';
import {NavLink} from "react-router-dom";
import { RiUserSettingsLine} from "react-icons/ri";
import {TbCategory2, TbChecklist, TbDiscount, TbHomeHeart} from "react-icons/tb";
import { useCart } from '../context/CartContext';
import {PiShoppingCartFill} from "react-icons/pi";



const Navbar = (props) => {
    const { cart } = useCart();

    return (
        <React.Fragment>
            <nav className="nav nav-pills nav-justified fixed-bottom rtl max-w-lg bg-white nav-bar-app">
                <NavLink className="nav-item nav-link  " to="/home">
                    <div><TbHomeHeart className='nav-icon'/></div>
                    <span>خانه</span>
                </NavLink>
                <NavLink className="nav-item nav-link  " to="/categories">
                    <div><TbCategory2 className='nav-icon'/></div>
                    <span>دسته ها</span>
                </NavLink>
                <NavLink className="nav-item nav-link d-none d-md-block " to="/search">
                    <div><RiUserSettingsLine className='nav-icon'/></div>
                    <span>جستجو</span>
                </NavLink>

                        <NavLink className="nav-item nav-link  " to="/requests">
                            <div><TbChecklist  className='nav-icon' /></div>
                            <span className="text-small-1 ">درخواست ها</span>
                        </NavLink>


                <NavLink className="nav-item nav-link  " to="/profile">
                    <div><RiUserSettingsLine className='nav-icon'/></div>
                    <span>حساب من</span>
                </NavLink>



            </nav>

        </React.Fragment>
    );
};

export default Navbar;
